<template>
    <tq-loader-container :p_tq-loader_b="true" :p_show-loader_b="!server_questExplore_c" :p_absolute-center_b="true" class="TQ_center">

        <div class="TQ_align_initial TQ_text_20px TQ_padding_8px TQ_bg_white">
            <tq-link class="TQ_text_remove_underline TQ_text_capitalize" :p_link_s="enum_moveToOptions.player_store"> {{ass_strings.oneWord_store[store_system_langCode_ve.val]}}</tq-link>
            >

            <span v-if="co_currentCategoryData_e">
                <tq-link class="TQ_text_remove_underline TQ_text_capitalize" :p_link_s="enum_moveToOptions.player_store_category + '/' + co_currentCategoryData_e">
                    <span v-if="co_currentCategoryData_e === enum_questCategories.virtual"> {{ass_strings.twoWords_virtualQuests[store_system_langCode_ve.val]}}</span>
                    <span v-if="co_currentCategoryData_e === enum_questCategories.teamWork"> {{ass_strings.threeWords_teamBuildingQuests[store_system_langCode_ve.val]}}</span>
                    <span v-if="co_currentCategoryData_e === enum_questCategories.selfGuided"> {{ass_strings.threeWords_selfGuidedQuests[store_system_langCode_ve.val]}}</span>
                    <span v-if="co_currentCategoryData_e === enum_questCategories.outside"> {{ass_strings.twoWords_outsideQuests[store_system_langCode_ve.val]}}</span>
                </tq-link>
                >
            </span>

            <span class="TQ_text_bold TQ_text_capitalize" v-if="server_questExplore_c">
                {{ server_questExplore_c.cm_qex_getName_fs(store_system_langCode_ve.val) }}
            </span>
        </div>

        <div v-if="server_questExplore_c" :class="{'TQ_padding_8px' : store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.tablet_small}">

            <!-- 1) quest explore info -->
            <div class="TQ_center TQ_inline TQ_maxWidth_600px TQ_width_100p"
                 :class="{'TQ_maxWidth_750px' : store_system_windowSizeType_ve.val === enum_screenSizesOptions_n.laptop}">

                <!-- 1.1) quest body -->
                <tq-quest-explore-header
                        class="TQ_bg_white TQ_margin_bottom_2px TQ_borderRadius_top TQ_box_shadow"
                        :pb_created-user-data_c="server_creatorData_c"
                        :pb_quest-explore_c="server_questExplore_c"
                        :pb_quest-explore-info_c="server_questExploreInfo_c"

                        :p_system_current-currency_e="store_system_currency_ve.val"
                        :ps_lang-code_e="store_system_langCode_ve.val"
                        :ps_screen-size_en="store_system_windowSizeType_ve.val"
                        :p_gallery-height_s="store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.tablet_small ?  '400px' : '250px'"

                        :p_always-show-slider_b="true"

                        :pf_loved-quest_b="server_currentUserLovedQuests_byQuestId_c[server_questExplore_c.qex_questId_uid] != null"
                        :pe_click-heart_fe="m_clickLoveQuest_f"
                />

                <!-- 1.2) basic info -->
                <div class="TQ_box_shadow TQ_bg_white TQ_margin_bottom_2px TQ_padding_16px_0px ">
                    <div class="TQ_padding_16px_0px TQ_center TQ_grid_col_1fr1fr1fr1fr1fr">

                        <!-- language -->
                        <div class="TQ_inline" :class="co_basicInfo_item_s">
                            <tq-image :pb_src_r="ass_img_language" pb_att_s="tq-language" :class="co_basicInfo_iconClass_s"/>

                            <div class="TQ_text_bold">
                                {{format_langArrCode(server_questExplore_c.qex_langArr_ae)}}
                            </div>
                        </div>

                        <!-- time -->
                        <div class="TQ_inline" :class="co_basicInfo_item_s" >
                            <tq-image :pb_src_r="ass_img_clock" pb_att_s="tq-time"  :class="co_basicInfo_iconClass_s"/>
                            <div class="TQ_text_bold">
                                {{format_duration_minutes(server_questExplore_c.qex_durationInMinutes_n, store_system_langCode_ve.val)}}
                            </div>
                        </div>

                        <!-- guide -->
                        <div class="TQ_inline" :class="co_basicInfo_item_s">
                            <div v-if="server_questExplore_c.qex_metadata_c.qexm_guide_b">
                                <tq-image :pb_src_r="ass_svg_guide_c" :class="co_basicInfo_iconClass_s"/>

                                <div class="TQ_text_bold">
                                    {{ass_strings.twoWords_withAGuide[store_system_langCode_ve.val]}}
                                </div>
                            </div>
                            <div v-else>
                                <tq-image :pb_src_r="ass_svg_noGuide_c"  :class="co_basicInfo_iconClass_s"/>
                                <div class="TQ_text_bold">
                                    {{ass_strings.twoWords_whitoutGuide[store_system_langCode_ve.val]}}
                                </div>
                            </div>
                        </div>

                        <!-- players -->
                        <div class="TQ_inline" :class="co_basicInfo_item_s">
                                <tq-image :pb_src_r="ass_img_playersGroup" :class="co_basicInfo_iconClass_s"/>

                                <div class="TQ_text_bold">
                                    {{server_questExplore_c.qex_minPlayersNum_n}}-{{server_questExplore_c.qex_maxPlayersNum_n}}
                                    {{ass_strings.oneWord_participants[store_system_langCode_ve.val]}}
                                </div>

                        </div>

                        <!-- location -->
                        <div class="TQ_inline" :class="co_basicInfo_item_s">
                            <tq-image :pb_src_r="ass_svg_map_c" :class="co_basicInfo_iconClass_s"/>
                            <div class="TQ_text_bold" v-if="server_questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocationsTypes_s.outside">
                                {{server_questExplore_c.qex_startingLocation_s}}
                            </div>
                            <div v-else>
                                {{ass_strings.oneWord_virtual[store_system_langCode_ve.val]}}
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 1.3) Creator  -->
                <div class="TQ_box_shadow TQ_padding_12px TQ_textAlign_initial TQ_bg_white  TQ_margin_bottom_4px " v-if="server_creatorData_c">

                    <div class="TQ_grid_col_auto1fr">

                        <tq-link :p_link_s="co_storeCreatorUrl_s" class="TQ_grid_verticalCenter TQ_clickable ">
                            <tq-avatar :p_ud_avatar_c="server_creatorData_c.ud_avatar_c" class="TQ_width_100px TQ_borderRadius TQ_bg_hover_shadow2"/>
                        </tq-link>

                        <div class="TQ_inline TQ_margin_8px TQ_grid_verticalCenter">


                            <div :class="{'TQ_grid_col_Auto1frAuto' : store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.mobile}">

                                <tq-link :p_link_s="co_storeCreatorUrl_s" class="TQ_text_remove_underline TQ_textColor_purple_dark TQ_text_bold TQ_grid_verticalCenter TQ_clickable ">
                                    <div class="TQ_text_24px ">
                                        {{server_creatorData_c.ud_name_s}}
                                    </div>
                                    <div class="TQ_text_16px TQ_margin_top_2px">
                                        <div class="TQ_bg_purple_dark TQ_borderRadius TQ_padding_0px_8px TQ_inline"> {{ ass_strings.oneWord_level[store_system_langCode_ve.val]}} {{server_creatorData_c.ud_m_level_s()}} </div>
                                        <div class="TQ_padding_2px TQ_inline"></div>
                                        <div class="TQ_text_14px TQ_inline"> ({{server_creatorData_c.ud_levelTotalPoints_n}} {{ ass_strings.oneWord_points[store_system_langCode_ve.val]}}) </div>
                                    </div>
                                </tq-link>


                                <div></div> <!-- space -->

                                <div class="TQ_grid_verticalCenter" v-if="server_creator_uds_moreInfo_c && server_creator_uds_moreInfo_c.udsmi_phone_s">

                                    <!-- phone number -->
                                    <div class="TQ_bg_blue_lite TQ_borderRadius TQ_box_shadow TQ_padding_1px TQ_inline TQ_clickable"
                                         v-if="!showCreatorPhoneNumber_b"
                                         @click="showCreatorPhoneNumber_b = true">
                                        <tq-image :pb_src_r="ass_img_phone_w" class="TQ_width_24px TQ_height_24px TQ_padding_6px TQ_border_white TQ_borderRadius TQ_verticalAlignMiddle" />
                                    </div>
                                    <div v-else-if="server_creator_uds_moreInfo_c" class="TQ_inline TQ_padding_8px TQ_direction_ltr">
                                        <a :href="'tel:' + server_creator_uds_moreInfo_c.udsmi_phone_s">
                                            {{server_creator_uds_moreInfo_c.udsmi_phone_s}}
                                        </a>
                                    </div>

                                    <!-- space -->
                                    <div class="TQ_padding_4px TQ_inline"></div>

                                    <!-- whats app -->
                                    <div class="TQ_bg_green TQ_borderRadius TQ_box_shadow TQ_inline TQ_padding_1px">
                                        <a :href="`https://api.whatsapp.com/send?phone=${server_creator_uds_moreInfo_c.udsmi_phone_s}`"
                                           target="_blank">
                                            <tq-image :pb_src_r="ass_img_whatsapp_w" class="TQ_width_24px TQ_padding_6px TQ_border_white TQ_borderRadius TQ_verticalAlignMiddle" />
                                        </a>
                                    </div>


                                </div>

                            </div>

                            <hr>

                            <tq-long-text
                                    v-if="server_creator_uds_moreInfo_c"
                                    :pb_max-length_n="100"
                                    :pb_text_s="server_creator_uds_moreInfo_c.udsmi_cm_about_fs(store_system_langCode_ve.val)"
                                    :ps_lang-code_e="store_system_langCode_ve.val"/>
                        </div>
                    </div>

                </div>

                <!-- 1.3) quest body -->
                <div class="TQ_box_shadow TQ_padding_8px TQ_textAlign_initial TQ_bg_white TQ_margin_bottom_8px">

                    <div class="TQ_padding_4px TQ_text_24px TQ_font_suezOne">{{ass_strings.oneWord_description[store_system_langCode_ve.val]}}</div>

                    <tq-long-text
                            class="TQ_padding_4px TQ_textColor_gray"
                            :pb_max-length_n="200"
                            :pb_text_s="server_questExplore_c.qex_description_cla_s[co_qex_displayLangCode_s]"
                            :ps_lang-code_e="store_system_langCode_ve.val"/>
                    <hr>

                    <div class="TQ_padding_4px TQ_text_24px TQ_font_suezOne">{{ass_strings.fourWords_whatYouWillGet[store_system_langCode_ve.val]}}</div>
                    <tq-long-text
                            class="TQ_padding_4px TQ_textColor_gray"
                            :pb_max-length_n="200"
                            :pb_text_s="server_questExplore_c.qex_whatYouWillGet_cla_s[co_qex_displayLangCode_s]"
                            :ps_lang-code_e="store_system_langCode_ve.val"/>
                    <hr>

                    <div class="TQ_padding_4px TQ_text_24px TQ_font_suezOne">{{ass_strings.threeWords_whatToBring[store_system_langCode_ve.val]}}</div>
                    <tq-long-text
                            class="TQ_padding_4px TQ_textColor_gray"
                            :pb_max-length_n="200"
                            :pb_text_s="server_questExplore_c.qex_whatToBring_cla_s[co_qex_displayLangCode_s]"
                            :ps_lang-code_e="store_system_langCode_ve.val"/>
                    <hr>

                    <div class="TQ_padding_4px TQ_text_24px TQ_font_suezOne">{{ass_strings.sentence_whatElseYouShouldKnow[store_system_langCode_ve.val]}}</div>
                    <tq-long-text
                            class="TQ_padding_4px TQ_textColor_gray"
                            :pb_max-length_n="200"
                            :pb_text_s="server_questExplore_c.qex_whatElse_cla_s[co_qex_displayLangCode_s]"
                            :ps_lang-code_e="store_system_langCode_ve.val"/>


                </div>

                <!-- 1.4) intro video-->
                <div class="TQ_bg_white TQ_box_shadow TQ_margin_bottom_16px TQ_padding_8px" v-if="server_questExplore_c.qex_introVideo_blc_c[co_qex_displayLangCode_s]">
                    <tq-display-file :file="server_questExplore_c.qex_introVideo_blc_c[co_qex_displayLangCode_s]" p_video-height_s=""></tq-display-file>
                </div>

                <!-- 1.5) map-->
                <div class="TQ_bg_white TQ_box_shadow TQ_margin_bottom_4px TQ_padding_8px"
                     v-if="server_questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocationsTypes_s.outside">

                    <tq-leaflet-display-simple
                            :key="co_qex_displayLangCode_s"
                            class="TQ_height_300px TQ_margin_bottom_8px TQ_borderRadius"
                            :pb_center-map_c="server_questExplore_c.qex_startingLocationPoint_c"
                            :p_display_lang-code_e="co_qex_displayLangCode_s"
                            :pb_zoom_n="15"
                            :p_markers_ac="co_startingLocation_markers_ac"/>

                    <div class="TQ_textAlign_initial TQ_grid_col_autoAuto1fr TQ_grid_gap_4px">
                        <tq-image :pb_src_r="ass_img_location" class="TQ_width_20px TQ_grid_verticalCenter "/>
                        <div class="TQ_grid_verticalCenter TQ_textColor_purple_dark TQ_text_bold ">
                            {{server_questExplore_c.qex_startingLocation_s}}
                        </div>
                    </div>
                </div>

                <!-- 1.6) reviews -->
                <div class="TQ_box_shadow TQ_padding_8px TQ_bg_white TQ_borderRadius_bottom" v-if="server_questReviews_ac">

                    <div v-if="server_questExploreInfo_c" class="TQ_grid_col_1fr1fr TQ_padding_16px TQ_maxWidth_600px TQ_center">

                        <div class="TQ_text_24px TQ_text_bold TQ_margin_bottom_4px TQ_grid_verticalCenter" >{{ass_strings.twoWords_overallRating[store_system_langCode_ve.val]}}</div>
                        <div class="TQ_text_24px TQ_text_bold TQ_margin_bottom_4px TQ_grid_verticalCenter" >{{ass_strings.twoWords_difficultyLevel[store_system_langCode_ve.val]}}</div>

                        <si_-stars class="TQ_verticalAlignMiddle TQ_grid_verticalCenter TQ_padding_4px" :rating="server_questExploreInfo_c.qexi_overallRatingAvg_n" p_stars-width_s="30px"/>
                        <tq-image class="TQ_width_72px TQ_padding_4px TQ_center TQ_grid_verticalCenter" :pb_src_r="helper_getDiffLevel_o(server_questExploreInfo_c.qexi_difficultyAvg_n, store_system_langCode_ve.val).img_r" pb_att_s="diffLevel TQ" />

                        <div class="TQ_grid_verticalCenter TQ_text_bold">
                            ({{helper_getGeneralRating_o(server_questExploreInfo_c.qexi_overallRatingAvg_n, store_system_langCode_ve.val).text_s}})
                        </div>

                        <div class="TQ_grid_verticalCenter TQ_text_bold">
                            ({{helper_getDiffLevel_o(server_questExploreInfo_c.qexi_difficultyAvg_n, store_system_langCode_ve.val).text_s}})
                        </div>

                    </div>

                    <hr>

                    <div v-for="questReview_c in server_questReviews_ac" class="TQ_padding_8px TQ_maxWidth_450px TQ_center">

                        <div class="TQ_grid_col_auto1fr TQ_grid_gap_16px"
                             v-if="server_reviewsUserData_byUserId_c[questReview_c.qr_reviewerId_uid]">

                            <div class="TQ_width_72px TQ_grid_center TQ_center">

                                <tq-avatar :p_ud_avatar_c="server_reviewsUserData_byUserId_c[questReview_c.qr_reviewerId_uid].ud_avatar_c"
                                           :key="$options.name + questReview_c.qr_reviewerId_uid"
                                           class="TQ_width_44px TQ_borderRadius TQ_center"/>


                                <div class="TQ_verticalAlignMiddle TQ_text_12px TQ_text_wordWrap">{{server_reviewsUserData_byUserId_c[questReview_c.qr_reviewerId_uid].ud_name_s}} </div>
                            </div>

                            <div class="TQ_textAlign_initial TQ_grid_row_auto1frAuto ">
                                <div class="TQ_grid_col_1frAutoAuto">
                                    <si_-stars :rating="questReview_c.qr_overallRating_n" class="TQ_grid_verticalCenter"/>

                                    <tq-image class="TQ_width_32px TQ_padding_4px TQ_center TQ_grid_verticalCenter" :pb_src_r="helper_getDiffLevel_o(questReview_c.qr_difficulty_n, store_system_langCode_ve.val).img_r" pb_att_s="diffLevel TQ" />

                                    <tq-select options-width="100px" :show-caret-down="false" class="TQ_width_24px TQ_grid_verticalCenter TQ_margin_-4px">

                                        <tq-image slot="select"  :pb_src_r="ass_three_dots" pb_att_s="review option"/>

                                        <div @click="() => {showPopup_reportReview_vb.val=true; reportReviewText_s=null; reportReviewReviewerId_uid=questReview_c.qr_reviewerId_uid}"
                                             slot="options" class="TQ_padding_8px TQ_text_14px TQ_bg_gray4 TQ_bg_hover_goldLite">
                                            {{ass_strings.oneWord_report[store_system_langCode_ve.val]}}
                                        </div>

                                    </tq-select>
                                </div>
                                <div class="TQ_text_selectable"> {{questReview_c.qr_publicFeedback_s}}</div>
                                <div class="TQ_text_12px TQ_textAlign_end">{{format_dateFull(questReview_c.qr_timestamp_t)}} </div>
                            </div>
                        </div>
                        <hr>
                    </div>

                    <tq-loader-button :show-loader="showMoreReviewsBtnLoader" v-if="!getAllReviews_b">
                        <div @click="m_getMoreReviews_f" class="TQ_padding_8px TQ_inline TQ_bg_purple TQ_margin_8px TQ_borderRadius TQ_clickable">
                            {{ass_strings.threeWords_loadMoreReviews[store_system_langCode_ve.val]}}
                        </div>
                    </tq-loader-button>

                </div>

                <!-- space for mobile mode -->
                <div class="TQ_padding_32px TQ_inline" v-if="server_questExploreInfo_c && store_system_windowSizeType_ve.val <= enum_screenSizesOptions_n.tablet_small"> </div>

            </div>

            <!-- 2) space -->
            <div class="TQ_margin_8px TQ_inline"> </div>

            <!-- 3-1) buy quest desktop-->
            <!-- <fcuc-buy-quest-ticket
                v-if=" server_questExploreInfo_c && store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.tablet_small"
                :key="server_questExplore_c.qex_questId_uid"

                class="lc_stickToTop TQ_verticalAlignTop TQ_width_100p TQ_maxWidth_350px TQ_align_initial TQ_inline "

                :ps_lang-code_e="store_system_langCode_ve.val"
                :p_system_current-currency_e="store_system_currency_ve.val"

                :p_quest-event_c="server_questEvent_c"
                :p_quest-explore_c="server_questExplore_c"
                :p_current-user-data_c="server_currentUserData_c"

                :ps_screen-size_e="store_system_windowSizeType_ve.val"
                :p_store_agent-id_uid="store_system_agentId_vUid.val"
                :p_show-currency_b="false"

                :pf_show-share-btns_b="true"

            /> -->

            <!-- 3-2) buy quest mobile-->
            <!-- <div v-else>

                 buy ticket btn 
                <div class="lc_checkAvailabilityBtn TQ_bg_purple_lite TQ_padding_2px TQ_borderRadius TQ_box_shadow2 TQ_margin_8px TQ_text_capitalize TQ_borderRadius"
                     :style="{'zIndex': gv_zIndex.player_order_btn}"
                     @click="showBuyQuestPopup.val = true">


                    <div v-if="store_system_scrollToBottom_vb.val" class="TQ_border_white TQ_bg_purple_lite TQ_borderRadius  TQ_text_20px TQ_animation_beacon">
                        <div class="TQ_padding_6px">
                            <tq-image  :pb_src_r="ass_img_shoppingBag_w" class="TQ_width_28px TQ_verticalAlignMiddle "/>
                            <div class="TQ_padding_24px TQ_inline TQ_verticalAlignMiddle"></div>
                            <div class="TQ_padding_2px TQ_inline TQ_verticalAlignMiddle">
                                {{ ass_strings.twoWords_buyNow[store_system_langCode_ve.val] }}
                            </div>
                        </div>

                    </div>


                    <div v-else class="TQ_border_white TQ_bg_purple_lite TQ_borderRadius  TQ_text_20px">
                        <tq-image  :pb_src_r="ass_img_shoppingBag_w" class="TQ_width_32px TQ_padding_6px TQ_verticalAlignMiddle"/>
                    </div>


                </div>

                buy ticket popup 
                <tq-popup :show="showBuyQuestPopup" max-width="350px " :show-close-btn="true" padding="0px">

                    <fcuc-buy-quest-ticket
                            v-if="server_questExploreInfo_c"
                            class="TQ_verticalAlignTop TQ_align_initial TQ_inline TQ_width_100p"

                            :p_system_current-currency_e="store_system_currency_ve.val"
                            :ps_lang-code_e="store_system_langCode_ve.val"

                            :p_quest-explore_c="server_questExplore_c"
                            :p_quest-event_c="server_questEvent_c"
                            :p_current-user-data_c="server_currentUserData_c"

                            :ps_screen-size_e="store_system_windowSizeType_ve.val"

                            :p_store_agent-id_uid="store_system_agentId_vUid.val"

                            :p_show-currency_b="false"
                    />

                </tq-popup>

            </div> -->

            <!-- 4) store chat  -->
            <a class="lc_whatsApp TQ_padding_2px TQ_bg_green TQ_margin_8px TQ_borderRadius TQ_box_shadow"
               v-if="server_creator_uds_moreInfo_c && server_creator_uds_moreInfo_c.udsmi_phone_s"
               :href="`https://api.whatsapp.com/send?phone=${server_creator_uds_moreInfo_c.udsmi_phone_s}`"
               target="_blank">
                <tq-image :pb_src_r="ass_img_whatsapp_w" class="TQ_width_32px TQ_border_white TQ_padding_6px TQ_borderRadius TQ_verticalAlignMiddle " />
            </a>

            <!-- popup send email -->
            <tq-popup :show="showPopup_sendEmail_vb" max-width="350px" :show-close-btn="true">

                <div class="TQ_padding_16px">

                    <!-- 0) title -->
                    <div class="TQ_text_24px  TQ_border_bottom">
                        {{ass_strings.twoWords_sendEmail[store_system_langCode_ve.val]}}
                    </div>
                    <div class="TQ_padding_8px"></div><!-- space -->

                    <!-- 1) name -->
                    <div class="TQ_align_initial TQ_text_bold">
                        {{ass_strings.oneWord_name[store_system_langCode_ve.val]}}
                    </div>
                    <tq-textarea
                            class=""
                            pb_uid_s="fullName"
                            pb_textarea-class_s="TQ_padding_4px"
                            pb_init-text_s=""
                            :pb_max-length_n="20"
                            :pb_placeholder_s="ass_strings.twoWords_yourName[store_system_langCode_ve.val]"
                            :pb_rows_n="1"
                            :pe_change-text_s="(text_s) => {sendEmail_name = text_s}"
                    />

                    <!-- 2) email -->
                    <div class="TQ_align_initial TQ_text_bold">
                        {{ass_strings.oneWord_email[store_system_langCode_ve.val]}}
                    </div>
                    <tq-textarea
                            pb_uid_s="fullName"
                            pb_textarea-class_s="TQ_padding_4px"
                            pb_init-text_s=""
                            :pb_max-length_n="40"
                            :pb_placeholder_s="ass_strings.sentence_emailAddressReply[store_system_langCode_ve.val]"
                            :pb_rows_n="1"
                            :pe_change-text_s="(text_s) => {sendEmail_email = text_s}"
                    />

                    <!-- 3) phone -->
                    <div class="TQ_align_initial TQ_text_bold">
                        {{ass_strings.twoWords_phoneNumber[store_system_langCode_ve.val]}}
                    </div>
                    <tq-textarea
                            pb_uid_s="fullName"
                            pb_textarea-class_s="TQ_padding_4px"
                            pb_init-text_s=""
                            :pb_max-length_n="10"
                            :pb_placeholder_s="ass_strings.twoWords_phoneNumber[store_system_langCode_ve.val]"
                            :pb_rows_n="1"
                            :pe_change-text_s="(text_s) => {sendEmail_phone = text_s}"
                    />

                    <!-- 4) msg -->
                    <div class="TQ_align_initial TQ_text_bold">
                        {{ass_strings.oneWord_message[store_system_langCode_ve.val]}}
                    </div>
                    <tq-textarea
                            class="TQ_margin_bottom_8px"
                            pb_uid_s="fullName"
                            pb_textarea-class_s="TQ_padding_4px"
                            pb_init-text_s=""
                            :pb_max-length_n="500"
                            :pb_placeholder_s="ass_strings.twoWords_yourMessage[store_system_langCode_ve.val] +'...'"
                            :pb_rows_n="10"
                            :pe_change-text_s="(text_s) => {sendEmail_msg = text_s}"
                    />

                    <tq-loader-button :show-loader="btn_showLoader_b">
                        <div class="TQ_padding_8px TQ_margin_top_8px TQ_bg_purple TQ_text_20px TQ_clickable" @click="m_sendEmailToCreator_f">
                            {{ass_strings.twoWords_sendEmail[store_system_langCode_ve.val]}}
                        </div>
                    </tq-loader-button>

                </div>

            </tq-popup>

            <!-- popup report  -->
            <tq-popup :show="showPopup_reportReview_vb" max-width="350px" :show-close-btn="true">
                <div class="TQ_text_28px TQ_textColor_purple TQ_text_bold">
                    {{ass_strings.twoWords_reportReview[store_system_langCode_ve.val]}}
                </div>
                <hr>

                <tq-textarea
                        pb_uid_s="report a review"
                        pb_textarea-class_s="TQ_padding_4px"
                        :pb_max-length_n="100"
                        :pb_placeholder_s="ass_strings.sentence_reportReview[store_system_langCode_ve.val]"
                        :pb_rows_n="4"
                        :pe_change-text_s="(text_s) => {reportReviewText_s = text_s}"
                />

                <hr>

                <div class="TQ_grid_col_Auto1frAuto">
                    <div class="TQ_padding_8px TQ_bg_gray4 TQ_borderRadius TQ_box_shadow TQ_clickable" @click="showPopup_reportReview_vb.val=false"> {{ass_strings.oneWord_cancel[store_system_langCode_ve.val]}}</div>
                    <div></div>
                    <div class="TQ_padding_8px TQ_bg_green TQ_borderRadius TQ_box_shadow TQ_clickable"
                         @click="m_reportReview_f">{{ass_strings.oneWord_send[store_system_langCode_ve.val]}}</div>
                </div>
            </tq-popup>

        </div>

    </tq-loader-container>
</template>

<script>

    import TqQuestExploreHeader from "../../../components/complex/TqQuestExploreHeader";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "@/store";
    import {
        enum_loginMethods,
        enum_questCategories,
        enum_questLocationsTypes_s,
        enum_TqClasses,
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqSelect from "../../../components/basic/TqDropdown";
    import TqPopup from "../../../components/basic/TqPopup";

    import FcucBuyQuestTicket from "../../../components/unpure/FcucBuyQuestTicket";
    import {
        server_userLoveQuest_f,
        serverPre_cl_currentUserLovedQuests_remove_f,
        serverPre_cl_currentUserLovedQuests_get_f,
        server_getQuestExploreInfo_f,
        server_questReviews_get_last3_f,
        serverPre_subUserData_moreInfo_get_f,
        server_sendMail_fp,
        serverPre_reportReview_set_f,
        server_questEvent_once_f,
    } from "@/scripts/Server/S_ServerPre";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        route_getCurrentFullPath_s,
        route_getUrlParams, route_urlLastPath_fs,
    } from "@/router";
    import {serverBig_questExplore_once_f} from "@/scripts/Server/S_ServerFirestore";
    import {
        ass_img_clock,

        ass_img_language,
        ass_svg_guide_c,
        ass_img_location,
        ass_img_playersGroup_b,
        ass_img_profit_b,
        ass_img_reviews_b,
        ass_img_shoppingCart_w,
        ass_img_user_b,
        ass_svg_noGuide_c,
        ass_svg_map_c,
        ass_img_threeDots,
        ass_img_shoppingBag_w,
        ass_svg_maze_circular_c,
        ass_img_chat_w,
        ass_img_xLetter_w,
        ass_svg_foreign_w, ass_img_whatsapp_w, ass_img_phone_w,
    } from "@/assets/scripts/Ass_Files";
    import {
        format_duration_minutes} from "../../../../functions/src/shareCode/Share_S_Format";
    import Si_Stars from "../../../components/a_smartIcons/si_Stars";
    import {obj_size_fn} from "../../../../functions/src/shareCode/Share_S_Obj";
    import TqLongText from "../../../components/basic/TqLongText";
    import {Tq_Laeflet_Marker} from "@/classes/TqClasses";
    import {gv_zIndex} from "@/scripts/S_GlobalVar";
    import {seo_updateDynamicValues_f} from "@/scripts/S_seo";
    import {format_date_YYYY_MM_DD_hh_mm_fs, format_langArrCode} from "../../../../functions/src/shareCode/Share_S_Format";
    import TqImage from "../../../components/basic/TqImage";
    import {
        FB_MapData,
        FB_SendEmail,
    } from "../../../../functions/src/shareCode/Share_S_Classes";
    import {
        enum_moveToOptions,
        enum_screenSizesOptions_n, enum_urlParams
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqTextarea from "../../../components/basic/TqTextarea";
    import {notification_notify, notification_notify2} from "@/scripts/S_Notification";
    import TqLoaderButton from "../../../components/basic2/TqLoaderButton";
    import TqLeafletDisplaySimple from "../../../components/maps/TqLeafletDisplaySimple";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f, serverAuth_currentUserData_update_f,
        serverAuth_getOtherUserData_f, serverAuth_login_guest_fp
    } from "@/scripts/Server/S_ServerAuth";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import TqDisplayFile from "../../../components/mediaComponenets/TqDisplayFile";
    import {helper_getDiffLevel_o, helper_getGeneralRating_o} from "@/scripts/S_Helper";
    import TqTextareaAutosize from "../../../components/basic/TqTextareaAutosize";
    import TqAvatar from "@/components/complex/TqAvatar";
    import TqLink from "@/components/basic/TqLink";
    import TqChat from "@/components/complex/TqChat_inputBar";
    import TqChat_messages from "@/components/complex/TqChat_messages";
    import TqChat_inputBar from "@/components/complex/TqChat_inputBar";
    import TqLogin from "@/components/complex/TqLogin";
    import TqCheckbox from "@/components/basic/TqCheckbox";
    import currentWebVersion_o from "../../../../currentVersion.json";
    import TqBtnApprove from "@/components/basic2/TqBtnApprove";

    export default {
        name: "v_Player_Store_Quest",
        components: {
            TqBtnApprove,
            TqCheckbox,
            TqLogin,
            TqChat_inputBar,
            TqChat_messages,
            TqChat,
            TqLink,
            TqAvatar,
            TqTextareaAutosize,
            TqDisplayFile,
            TqLoaderContainer,
            TqLeafletDisplaySimple,
            TqLoaderButton,
            TqTextarea,
            TqImage,
            TqLongText,
            FcucBuyQuestTicket,
            Si_Stars,
            TqPopup,
            TqSelect,
            TqQuestExploreHeader
        },
        data() {
            return {

                showCreatorPhoneNumber_b: false,
                showPopup_sendEmail_vb: {val: false},
                showPopup_reportReview_vb: {val: false},
                btn_showLoader_b: false,
                showBuyQuestPopup: {val: false},
                selectedTicket_vc: {val: null},
                selectedQuestEvent_vc: {val: null},
                reviewLastTimestamp_t: null,
                getAllReviews_b: false,
                showMoreReviewsBtnLoader: false,
                tempMapData_c: new FB_MapData({}),

                reportReviewText_s : null,
                reportReviewReviewerId_uid : null,

                sendEmail_name: "",
                sendEmail_email: "",
                sendEmail_phone: "",
                sendEmail_msg: "",

                // server
                server_questReviews_ac: [],
                server_reviewsUserData_byUserId_c: {},

                server_questExplore_c: undefined,
                server_questEvent_c: undefined,
                server_questExploreInfo_c: undefined,
                server_questEvents_ac: [],
                server_creatorData_c: undefined,
                server_creator_uds_moreInfo_c: undefined,
                server_currentUserData_c: undefined,
                server_currentUserLovedQuests_byQuestId_c: {},
                server_storeChat_c : undefined,
                server_storeChatCreatorMsg_c : undefined,

                // store
                store_system_langCode_ve: store_getStateValue_vo(store_var.system_langCode),
                store_system_agentId_vUid: store_getStateValue_vo(store_var.player_agentId_uid),
                store_system_currency_ve: store_getStateValue_vo(store_var.system_currency),
                store_system_windowSizeType_ve: store_getStateValue_vo(store_var.system_windowSizeType_e),
                store_system_scrollToBottom_vb: store_getStateValue_vo(store_var.system_scrollToBottom_b),
                store_fbAuth_vc : store_getStateValue_vo(store_var.fb_auth),

                local_currentWebVersion_o   : currentWebVersion_o,

                // imports
                ass_strings: ass_strings,
                ass_img_language: ass_img_language,
                ass_img_clock: ass_img_clock,
                ass_img_profit_b: ass_img_profit_b,
                ass_img_playersGroup: ass_img_playersGroup_b,
                ass_svg_guide_c: ass_svg_guide_c,
                ass_svg_noGuide_c: ass_svg_noGuide_c,

                ass_img_chat_w: ass_img_chat_w,
                ass_img_whatsapp_w: ass_img_whatsapp_w,
                ass_img_phone_w: ass_img_phone_w,
                ass_img_xLetter_w: ass_img_xLetter_w,
                ass_img_reviews_b: ass_img_reviews_b,
                ass_img_location: ass_img_location,
                ass_svg_maze_circular_c: ass_svg_maze_circular_c,
                ass_svg_map_c: ass_svg_map_c,
                ass_img_user_b: ass_img_user_b,
                ass_three_dots: ass_img_threeDots,
                ass_svg_foreign_w: ass_svg_foreign_w,

                ass_img_shoppingCart_w: ass_img_shoppingCart_w,
                ass_img_shoppingBag_w: ass_img_shoppingBag_w,
                format_dateFull: format_date_YYYY_MM_DD_hh_mm_fs,
                obj_size_fn: obj_size_fn,
                enum_questLocationsTypes_s: enum_questLocationsTypes_s,
                enum_screenSizesOptions_n: enum_screenSizesOptions_n,
                enum_moveToOptions: enum_moveToOptions,
                enum_questCategories: enum_questCategories,
                format_langArrCode: format_langArrCode,
                format_duration_minutes: format_duration_minutes,
                gv_zIndex: gv_zIndex,
                helper_getDiffLevel_o: helper_getDiffLevel_o,
                helper_getGeneralRating_o: helper_getGeneralRating_o
            }
        },
        computed: {
            co_startingLocation_markers_ac(){
                return [new Tq_Laeflet_Marker({
                    ltm_text_s      : this.server_questExplore_c.qex_startingLocation_s,
                    ltm_location_c  : this.server_questExplore_c.qex_startingLocationPoint_c
                })]
            },
            co_qex_displayLangCode_s(){
                return this.server_questExplore_c.cm_qex_getDisplayLang_fe(this.store_system_langCode_ve.val)
            },
            co_basicInfo_iconClass_s(){

                if(this.store_system_windowSizeType_ve.val> enum_screenSizesOptions_n.tablet_small){
                    return enum_TqClasses.TQ_width_44px
                }else{
                    return enum_TqClasses.TQ_width_32px
                }
            },
            co_basicInfo_item_s(){
                if(this.store_system_windowSizeType_ve.val> enum_screenSizesOptions_n.tablet_small){
                    return ''
                }else{
                    return enum_TqClasses.TQ_text_14px
                }
            },
            co_storeCreatorUrl_s(){
                return enum_moveToOptions.player_store_creator + "/" + this.server_creatorData_c.ud_m_getUrlFromEmail_fs()
            },
            co_currentCategoryData_e() {
                let fullPath_s = route_getCurrentFullPath_s()

                for(let questCategory_e in enum_questCategories){
                    if(fullPath_s.includes(questCategory_e))
                        return questCategory_e
                }
                return null
            },
        },
        methods:{
            m_clickLoveQuest_f(){
                if(this.server_currentUserData_c == null){
                    return
                }

                let lovedQuest_b = this.server_currentUserLovedQuests_byQuestId_c[this.server_questExplore_c.qex_questId_uid] != null
                server_userLoveQuest_f(this.server_currentUserData_c.ud_userId_uid, this.server_questExplore_c, lovedQuest_b)
            },
            m_sendEmailToCreator_f(){

                this.btn_showLoader_b = true

                let msg_s   = "<pre>" + this.sendEmail_msg + "</pre>"
                let questName_s  = "<div> Quest: "  + this.server_questExplore_c.qex_name_byLangCode_s[this.co_qex_displayLangCode_s] + "</div>"
                let name_s  = "<div> Name: "  + this.sendEmail_name + "</div>"
                let email_s = "<div> Email: " + this.sendEmail_email + "</div>"
                let phone_s = "<div> Phone: " + this.sendEmail_phone + "</div>"

                let sendEmail_c = new FB_SendEmail({
                    se_sendToEmail_s: this.server_creatorData_c.ud_email_s,
                    se_title_s      : ass_strings.threeWords_receivedMsgFrom[this.store_system_langCode_ve.val] + " " + this.sendEmail_name,
                    se_message_s    : msg_s + name_s + email_s + phone_s + questName_s,
                })

                server_sendMail_fp(sendEmail_c).then( () => {
                    this.btn_showLoader_b = false
                    this.showPopup_sendEmail_vb.val = false
                    notification_notify(ass_strings.twoWords_sentEmail)
                })

            },
            m_getMoreReviews_f(){

                this.showMoreReviewsBtnLoader = true

                server_questReviews_get_last3_f(this.server_questExplore_c.qex_questType_e, this.server_questExplore_c.qex_questId_uid, this.reviewLastTimestamp_t,
                    (questReview_ac, lastTimestamp_t) => {

                        this.showMoreReviewsBtnLoader = false

                        if(lastTimestamp_t == null){
                            this.getAllReviews_b = true
                            return
                        }

                        this.server_questReviews_ac = this.server_questReviews_ac.concat(questReview_ac)
                        this.reviewLastTimestamp_t = lastTimestamp_t

                        questReview_ac.forEach(questReview_c => {
                            serverAuth_getOtherUserData_f(questReview_c.qr_reviewerId_uid, (userData_c) => {
                                this.$set(this.server_reviewsUserData_byUserId_c, userData_c.ud_userId_uid, userData_c)
                            })
                        })
                    })
            },
            m_reportReview_f(){

                if(this.reportReviewText_s == null || this.reportReviewText_s.length < 5 || this.server_currentUserData_c == null){
                    return
                }
                this.showPopup_reportReview_vb.val=false

                serverPre_reportReview_set_f({
                    questType_e: this.server_questExplore_c.qex_questType_e,
                    questId_uid : this.server_questExplore_c.qex_questId_uid,
                    reviewerUserId_uid : this.reportReviewReviewerId_uid,
                    reportUserId_uid : this.server_currentUserData_c.ud_userId_uid,
                    reportText_s: this.reportReviewText_s,
                    cb_f : () => {
                        notification_notify2({title_s :ass_strings.twoWords_sentReport[this.store_system_langCode_ve.val]})
                    }
                })
            },
        },

        // ========= vueLifeCircle ===========
        mounted(){

            let agentId = route_getUrlParams(this.$route, enum_urlParams.agentId)

            if(agentId != null){
                store_setStateValue(store_var.player_agentId_uid, agentId)
            }

            serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {
                this.server_currentUserData_c = userData_c

                if(userData_c == null){return}

                // 2) get currentUserLovedQuests
                serverPre_cl_currentUserLovedQuests_get_f(this.$options.name, userData_c,
                    (questPointer_c) => {
                        this.$set(this.server_currentUserLovedQuests_byQuestId_c, questPointer_c.qp_questId_uid, questPointer_c)
                    },
                    () => {},
                    (questId_uid) => {
                        this.$delete(this.server_currentUserLovedQuests_byQuestId_c,questId_uid)
                    })
            })
        },
        activated() {

            let eventId_uid = route_getUrlParams(this.$route, enum_urlParams.eventId)

            let questId_uid = route_urlLastPath_fs()

            // check if return to the same page
            if(this.server_questExplore_c && this.server_questExplore_c.qex_questId_uid === questId_uid){return}

            // 0) clean last order
            this.server_creatorData_c = null;
            this.server_questExplore_c = null;
            this.server_questEvent_c = null;
            this.server_creator_uds_moreInfo_c = null;
            this.showCreatorPhoneNumber_b = false
            this.btn_showLoader_b = false

            // 1) get quest explore
            serverBig_questExplore_once_f(questId_uid, false, (questExplore_c) => {

                this.server_questExplore_c = questExplore_c

                if(eventId_uid != null){
                    server_questEvent_once_f(this.server_questExplore_c.qex_questType_e, this.server_questExplore_c.qex_questId_uid, eventId_uid, false, (questEvent_c) => {
                        this.server_questEvent_c = questEvent_c
                    })
                }

                const langCode_e = this.server_questExplore_c.cm_qex_getDisplayLang_fe(this.store_system_langCode_ve.val)

                seo_updateDynamicValues_f({
                    title_s         : this.server_questExplore_c.qex_name_byLangCode_s[langCode_e],
                    description_s   : this.server_questExplore_c.qex_description_cla_s[langCode_e],
                    imagePath_s         : this.server_questExplore_c.qex_imgsFiles_blc_ac[langCode_e][0].fi_url_s,
                })

                // 2) get creatorDAta
                serverAuth_getOtherUserData_f(this.server_questExplore_c.qex_creatorId_uid, userData_c =>{
                    this.server_creatorData_c = userData_c;

                    serverPre_subUserData_moreInfo_get_f({
                        userId_uid : userData_c.ud_userId_uid,
                        cb_f : (uds_moreInfo_c) => {
                            this.server_creator_uds_moreInfo_c = uds_moreInfo_c
                        }
                    })

                })

                // 4) server_questExploreInfo_c
                server_getQuestExploreInfo_f(this.server_questExplore_c, (questExploreInfo_c) => {
                    this.server_questExploreInfo_c = questExploreInfo_c
                })

                // 5) server_questExploreInfo_c
                this.server_questReviews_ac = []
                this.server_reviewsUserData_byUserId_c = {}
                this.reviewLastTimestamp_t = null
                this.getAllReviews_b = false
                this.getAllReviews_b = false

                // 6) get reviews
                this.m_getMoreReviews_f()

            })


        },
        deactivated(){
            if(this.server_questExplore_c != null){
                // server_questEvents_cl_remove_f(this.$options.name, this.server_questExplore_c.qex_questType_e, this.server_questExplore_c.qex_questId_uid)
            }
        },
        destroyed(){
            serverAuth_currentUserData_remove_vl_f(this.$options.name, this.$options.name)

            if(this.server_currentUserData_c){
                serverPre_cl_currentUserLovedQuests_remove_f(this.$options.name,this.server_currentUserData_c.ud_userId_uid)
            }
        },
    }

</script>

<style scoped lang="scss">


    .lc_checkAvailabilityBtn{
        position: fixed;
        bottom: var(--bottomBar);
        left: 0px;
    }


    .lc_stickToTop{
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 0;
        /*margin-top: 64px;*/
        /*margin-right: 8px;*/
    }

    .lc_whatsApp{
        position: fixed;
        bottom: calc(var(--bottomBar));
        right: 0px;

    }



</style>